import { gql } from '@apollo/client';

export const GET_EDIT_BOOK = gql`
  query GetEditBook($id: ID!) {
    getBook(id: $id) {
      id
      title
      subtitle
      author
      comment
      price
      isbn
      contactEmail
      contactPhone
      condition {
        id
        name
      }
      product {
        id
        title
        subtitle
        thumbnail
        author
        isbn
      }
      user {
        id
        name
        phone
        email
      }
    }
  }
`;
